// extracted by mini-css-extract-plugin
module.exports = {"modal":"_3l0IQa","image":"_3f8ArA"};